// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"02990332","283":"0fd94d7d","453":"b73b3b38","526":"6a35b178"}[chunkId] + ".chunk.js";
};